import { OrderStatus } from "../enums";

const DELETABLE_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.ACK,
  OrderStatus.ALLOCATED,
  OrderStatus.CANCELLED,
];

const DELETABLE_SUPPLIER_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.ACK,
  OrderStatus.PICKED,
  OrderStatus.IN_REVIEW,
  OrderStatus.REVOKED,
];

export function isUserInDevsUserIdsConfig(
  userId: string | undefined,
  devsUserIds: string[] | undefined,
): boolean {
  if (!userId || !devsUserIds?.length) {
    return false;
  }
  const normalizedUserId = String(userId).toLowerCase();
  return devsUserIds.some(
    (id) => String(id).trim().toLowerCase() === normalizedUserId,
  );
}

export function getDeleteOrderDisabled(
  orderStatus: string | undefined,
  orderType: string | undefined,
  userRole: string | undefined,
  isDeleted: boolean | undefined,
  activeSupplierStatus?: string | undefined,
  canVoidAtAnyState = false,
): boolean {
  // Already deleted
  if (isDeleted) {
    return true;
  }

  // Role check
  if (
    userRole !== "EXECUTIVE" &&
    userRole !== "HEAD_OF_OPERATIONS" &&
    userRole !== "CODE_ALCHEMISTS"
  ) {
    return true;
  }

  // Order type check
  if (orderType !== "REGULAR") {
    return true;
  }

  // Status check — allowlisted devs can void at any order status
  if (
    !canVoidAtAnyState &&
    (!orderStatus ||
      !DELETABLE_STATUSES.includes(orderStatus as OrderStatus))
  ) {
    return true;
  }

  // Supplier status check — skipped for allowlisted devs
  if (
    !canVoidAtAnyState &&
    activeSupplierStatus &&
    !DELETABLE_SUPPLIER_STATUSES.includes(activeSupplierStatus as OrderStatus)
  ) {
    return true;
  }

  return false;
}

export function getDeleteOrderTooltip(
  orderStatus: string | undefined,
  orderType: string | undefined,
  userRole: string | undefined,
  isDeleted: boolean | undefined,
  activeSupplierStatus?: string | undefined,
  canVoidAtAnyState = false,
): string {
  // Already voided
  if (isDeleted) {
    return "Order is already voided";
  }

  // Role check
  if (
    userRole !== "EXECUTIVE" &&
    userRole !== "HEAD_OF_OPERATIONS" &&
    userRole !== "CODE_ALCHEMISTS"
  ) {
    return "Only HOO, Executive, and Tech Team can void orders";
  }

  // Order type check
  if (orderType !== "REGULAR") {
    return "Only REGULAR orders can be voided";
  }

  // Status check — allowlisted devs can void at any order status
  if (
    !canVoidAtAnyState &&
    (!orderStatus ||
      !DELETABLE_STATUSES.includes(orderStatus as OrderStatus))
  ) {
    return "Order status must be NEW, ACK, ALLOCATED, or CANCELLED";
  }

  // Supplier status check — skipped for allowlisted devs
  if (
    !canVoidAtAnyState &&
    activeSupplierStatus &&
    !DELETABLE_SUPPLIER_STATUSES.includes(activeSupplierStatus as OrderStatus)
  ) {
    return "Active supplier status must be NEW, ACK, PICKED, IN-REVIEW, or REVOKED";
  }

  return "Void Order";
}
